import React from "react";
import { func, array, bool } from "prop-types";
import { Formik, Form } from "formik";
import { Col, Row } from "reactstrap";
import { LabeledSelect, FieldSpy } from "../../../../components/formik";

import { loginUserValidationSchema } from "../../validation-schemas/loginUserValidationSchema";

import { ButtonWithSpinner } from "../../../../components/common";

import "./loginForm.css";

const LoginOidcForm = ({ handleSubmit, organizations, isLoading }) => {
  const organizationOptions = organizations.map((n) => ({
    value: n.id,
    label: n.description !== "" ? n.description : n.name,
  }));
  const handleAuthorityUrlChange = (organizationId) => {
    const organization = organizations.find((org) => org.id === organizationId);

    localStorage.setItem("orgName", organization.name);
    localStorage.setItem("authorityUrl", organization.authorityUrl);
    localStorage.setItem("orgName", organization.name);
  };
  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{ organizationId: "" }}
      validationSchema={loginUserValidationSchema}
      enableReinitialize
    >
      <React.Fragment>
        <Form className="login-user-oidc-form">
          <Row>
            <Col sm="12" md={{ size: 8, offset: 2 }}>
              <div className="login-form-container">
                <div>
                  <Row>
                    <Col sm="12">
                      <LabeledSelect
                        placeholder="Organization:"
                        name="organizationId"
                        options={organizationOptions}
                        className="dropdown-group"
                      />
                      <FieldSpy
                        name="organizationId"
                        onChange={handleAuthorityUrlChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" className="d-flex justify-content-center mt-5">
                      <ButtonWithSpinner
                        className="login-button"
                        text="Sign In"
                        outline
                        type="submit"
                        loading={isLoading}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    </Formik>
  );
};
LoginOidcForm.propTypes = {
  handleSubmit: func.isRequired,
  organizations: array,
  isLoading: bool,
};

export default LoginOidcForm;



// WEBPACK FOOTER //
// ./src/features/login/components/login-oidc-form/LoginOidcForm.jsx